/**
 * Custom Scripts for Theme
  */
(function($) {

	// Video Modals
	$('.modal.video').on('hide.bs.modal', function(){
		$('.modal.video iframe').attr('src','');
	});
	$('.video-modal-btn').on('click', function(evt){
	  var target_modal = $(evt.currentTarget).attr('data-target');
	  var video_el = $($(evt.currentTarget).attr('data-video') + ' iframe').clone();
	  $(target_modal + ' .embed-responsive iframe').remove();
	  $(target_modal + ' .embed-responsive').append(video_el);
	});
	

	
	var $grid = $('#photo-grid').masonry({
	  itemSelector: '.grid-item',
	  percentPosition: true,
	  columnWidth: '.grid-sizer'
	});

	$grid.imagesLoaded().progress( function() {
	  $grid.masonry();
	  $('#photo-grid').addClass('loaded');
	});

	$('#photo-grid .grid-item').on('click', openPhotoModal);

	function openPhotoModal(evt){
		let photoIndex = parseInt($(evt.currentTarget).attr('photo-index'));
		$('#photo-carousel').carousel(photoIndex);
		$('#photo-modal').modal('show');
	}

	// Photography Albums
	//$('.photo-album-teaser').on('click',openPhotoAlbum);
	
	function openPhotoAlbum(evt){
	    evt.preventDefault();

	    let $modal = $('#photo-modal');
	    let $link = $(this);
	    let album_id = $(this).attr('data-album-id');

	    $.ajax({
	        url: wpvars.ajaxurl,
	        type: 'post',
	        data: {
	            action: 'fetch_photo_album',
	            post_id: album_id
	        },
	        beforeSend: function() {
	            $('#photo-modal .modal-dialog').html('<div class="modal-content loading"><div class="modal-body"><div class="load-status">Loading Photo Album</div> <div class="icon"><i class="fas fa-spinner fa-spin"></i></div></div></div>');
	            $modal.modal('show');
	        },
	        success: function( html ) {
	        	$('#photo-modal .modal-dialog').html(html);
	        }
	    });
	}


})(jQuery);

